import { makeStyles } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
// import TableCellAvatar from "@saleor/components/TableCellAvatar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TableHead from "@saleor/components/TableHead";
import TablePagination from "@saleor/components/TablePagination";
import { maybe, renderCollection } from "@saleor/misc";
import { ShipmentList_shipments_edges_node } from "@saleor/shipment/types/ShipmentList";
import { shipmentListUrlSortField } from "@saleor/shipment/urls";
import { ListActions, ListProps, SortPage } from "@saleor/types";
import { getArrowDirection } from "@saleor/utils/sort";
import moment from "moment-timezone";
import React from "react";
import { FormattedMessage } from "react-intl";

export interface ShipmentListProps
  extends ListProps,
    ListActions,
    SortPage<shipmentListUrlSortField> {
  shipment: ShipmentList_shipments_edges_node[];
}
const numberOfColumns = 6;

const useStyles = makeStyles(
  theme => ({
    [theme.breakpoints.up("lg")]: {
      apply: {
        width: 80
      },
      colName: {
        width: "auto",
        textAlign: "left"
      },
      displayoredr: {
        width: 80,
        textAlign: "center"
      },
      updatedate: {
        width: 160,
        textAlign: "center"
      }
    },
    apply: {
      color: "red"
    }
  }),
  { name: "CurrencyrateList" }
);
const Shipments: React.FC<ShipmentListProps> = ({
  shipment,
  disabled,
  isChecked,
  onNextPage,
  onPreviousPage,
  onRowClick,
  pageInfo,
  selected,
  sort,
  toggle,
  toggleAll,
  toolbar,
  onSort,
  settings,
  onUpdateListSettings
}) => {
  const classes = useStyles();
  return (
    <ResponsiveTable>
      <TableHead
        colSpan={numberOfColumns}
        selected={selected}
        disabled={disabled}
        items={shipment}
        toggleAll={toggleAll}
        toolbar={toolbar}
      >
        <TableCellHeader
          direction={
            sort.sort === shipmentListUrlSortField.orderNumber
              ? getArrowDirection(sort.asc)
              : undefined
          }
          className={classes.colName}
          onClick={() => onSort(shipmentListUrlSortField.orderNumber)}
        >
          <FormattedMessage defaultMessage="orderNumber" />
        </TableCellHeader>

        <TableCellHeader
          direction={
            sort.sort === shipmentListUrlSortField.trackingNumber
              ? getArrowDirection(sort.asc)
              : undefined
          }
          className={classes.colName}
          onClick={() => onSort(shipmentListUrlSortField.trackingNumber)}
        >
          <FormattedMessage defaultMessage="trackingNumber" />
        </TableCellHeader>

        <TableCellHeader
          direction={
            sort.sort === shipmentListUrlSortField.trackingCode
              ? getArrowDirection(sort.asc)
              : undefined
          }
          className={classes.colName}
          onClick={() => onSort(shipmentListUrlSortField.trackingCode)}
        >
          <FormattedMessage defaultMessage="trackingCode" />
        </TableCellHeader>

        <TableCellHeader
          direction={
            sort.sort === shipmentListUrlSortField.shipedDate
              ? getArrowDirection(sort.asc)
              : undefined
          }
          className={classes.colName}
          onClick={() => onSort(shipmentListUrlSortField.shipedDate)}
        >
          <FormattedMessage defaultMessage="shipedDate" />
        </TableCellHeader>

        {/* <TableCell className={classes.colName} style={{textAlign:"center",padding:0,margin:0}}>
                    <FormattedMessage defaultMessage="istop" />
                </TableCell> */}

        <TableCellHeader
          direction={
            sort.sort === shipmentListUrlSortField.shipedDelivered
              ? getArrowDirection(sort.asc)
              : undefined
          }
          className={classes.colName}
          onClick={() => onSort(shipmentListUrlSortField.shipedDelivered)}
          textAlign={"center"}
        >
          <FormattedMessage defaultMessage="shipedDelivered" />
        </TableCellHeader>
      </TableHead>

      <TableFooter>
        <TableRow>
          <TablePagination
            colSpan={numberOfColumns}
            settings={settings}
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            onNextPage={onNextPage}
            onUpdateListSettings={onUpdateListSettings}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onPreviousPage={onPreviousPage}
          />
        </TableRow>
      </TableFooter>

      <TableBody>
        {renderCollection(
          shipment,
          shipment => {
            const isSelected = shipment ? isChecked(shipment.id) : false;
            return (
              <TableRow
                hover={!!shipment}
                onClick={shipment && onRowClick(shipment.id)}
                key={shipment ? shipment.id : "skeleton"}
                selected={isSelected}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isSelected}
                    disabled={disabled}
                    disableClickPropagation
                    onChange={() => toggle(shipment.id)}
                  />
                </TableCell>

                <TableCell className={classes.colName} data-test="id">
                  {maybe<React.ReactNode>(
                    () => shipment.orderNumber,
                    <Skeleton />
                  )}
                </TableCell>

                <TableCell
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    paddingRight: "0px"
                  }}
                  className={classes.colName}
                  data-test="id"
                >
                  {maybe<React.ReactNode>(
                    () => shipment.trackingNumber,
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.colName} data-test="id">
                  {maybe<React.ReactNode>(
                    () => shipment.courierCode,
                    <Skeleton />
                  )}
                </TableCell>

                <TableCell className={classes.colName}>
                  {shipment ? (
                    moment(shipment.shipedDate).format("YYYY-MM-DD HH:mm:ss")
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>

                <TableCell className={classes.colName}>
                  {shipment ? (
                    moment(shipment.shipedDelivered).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>

                {/* <TableCell  padding="checkbox" style={{textAlign:"center"}}>
                                    <Checkbox
                                        checked={maybe(() => shipment.istop)}
                                    />
                                </TableCell> */}
              </TableRow>
            );
          },
          () => (
            <TableRow data-test="emptyListMessage">
              <TableCell colSpan={numberOfColumns}>
                <FormattedMessage defaultMessage="No shipment found" />
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </ResponsiveTable>
  );
};
export default Shipments;
